import { observer } from 'mobx-react';

import crownPillowImg from '../../../assets/crown-dialog/crown-pillow.webp';
import { useStores } from '../../../stores/useStores';
import classes from '../DailyMissions.module.scss';

import { DailyMissionTimer } from './DailyMissionTimer';

export const DailyMissionWidget = observer(() => {
  const { dailyMissionsStore } = useStores();
  const { currentDailyMission } = dailyMissionsStore;

  if (!currentDailyMission || currentDailyMission.status !== 'UPCOMING') {
    return null;
  }

  const onClickHandler = () => {
    dailyMissionsStore.setDialogVisible(true);
  };

  return (
    <div className={classes.dailyMissionWidget} onClick={onClickHandler}>
      <div className={classes.circle}></div>
      <img alt="crown" className={classes.crownPillowImg} loading="lazy" src={crownPillowImg} />
      <DailyMissionTimer className={classes.widgetTimer} />
    </div>
  );
});
